import { useReveal } from "../../hooks/useReveal2";
import PhoneMockup from "../../illustrations/PhoneMockup";
import "./AppDownload.css";

export default function AppDownload() {
  const scopeRef = useReveal();

  return (
    <section id="application" className="app-download" ref={scopeRef}>
      <div className="app-download-inner">
        <div className="app-download-copy reveal">
          <p className="eyebrow">📲 On your phone</p>
          <h2 className="section-title">
            Take school with you wherever you go
          </h2>
          <p className="app-download-text">
            The MASOMO App also works offline : download your lessons, study
            without an internet connection, and sync your progress as soon as
            you're back online. Available on Andoid and iOS.
          </p>

          <div className="store-buttons">
            <a
              href="#"
              className="store-btn"
              aria-label="Télécharger MASOMO sur Google Play"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M3.6 2.2c-.4.3-.6.8-.6 1.4v17c0 .6.2 1 .6 1.4l.1.1L13.3 12l-9.6-9.9-.1.1Z"
                />
                <path
                  fill="currentColor"
                  d="m16.5 15.2-3.2-3.2 3.2-3.2 3.9 2.2c.9.5.9 1.5 0 2l-3.9 2.2Z"
                  opacity="0.7"
                />
                <path
                  fill="currentColor"
                  d="M13.3 12 3.7 21.8c.4.3 1 .3 1.6 0l11-6.2-3-3.6Z"
                  opacity="0.85"
                />
                <path
                  fill="currentColor"
                  d="M13.3 12 5.3 2.2c-.6-.3-1.2-.3-1.6 0l9.6 9.8Z"
                  opacity="0.85"
                />
              </svg>
              <span>
                <small>Available on</small>
                Google Play
              </span>
            </a>

            <a
              href="#"
              className="store-btn"
              aria-label="Télécharger MASOMO sur l'App Store"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M17.6 12.5c0-2.6 2.1-3.8 2.2-3.9-1.2-1.8-3.1-2-3.7-2-1.6-.2-3.1.9-3.9.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.1 2.5-1.8 3.1-.5 7.6 1.3 10.1.9 1.2 1.9 2.6 3.2 2.6 1.3-.1 1.8-.8 3.3-.8 1.5 0 2 .8 3.3.8 1.4 0 2.2-1.2 3-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.6-3.9Z"
                />
                <path
                  fill="currentColor"
                  d="M14.9 5c.7-.8 1.1-1.9 1-3-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.8-1 2.9 1.1.1 2.2-.6 2.9-1.4Z"
                />
              </svg>
              <span>
                <small>Download on</small>
                App Store
              </span>
            </a>
          </div>
        </div>

        <div className="app-download-visual reveal reveal-delay-2">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
